module.exports = __webpack_public_path__ + "img/header-6.7a3f4e09.png";